/* B4 custom related posts.
 *
 * post.hbs renders a hidden candidate pool of post-cards (channel-first, then a site-wide
 * top-up) plus a tag-rarity map. This script scores each candidate and reveals the best four.
 *
 * Scoring (best-of-both: count AND rarity):
 *   score = sum over SHARED real tags of (1 / postcount(tag))
 *           -> a rare shared tag is worth more than a common one,
 *              and sharing more tags accumulates a higher score.
 *   tie-break 1: prefer a post in the same channel
 *   tie-break 2: more recent
 *
 * Fallback: a candidate with zero shared tags scores 0 and sinks below any real match; among
 * the zero-shared group, same-channel + recency wins -> "recent same-channel posts".
 *
 * CSS (.rp-related ... :nth-child(n+5)) hides everything past the 4th card, so JS-off visitors
 * still see the recent same-channel cards rendered first, and hidden cards never load images.
 */
(function () {
    'use strict';

    var section = document.querySelector('[data-rp-related]');
    if (!section) { return; }

    var feed = section.querySelector('[data-rp-related-feed]');
    if (!feed) { return; }

    function toSet(value, splitter) {
        var out = {};
        (value || '').trim().split(splitter).forEach(function (item) {
            if (item) { out[item] = true; }
        });
        return out;
    }

    var myTags = toSet(section.getAttribute('data-rp-tags'), /\s+/);
    var myChannels = toSet(section.getAttribute('data-rp-channel'), /\s+/);

    // Tag rarity map: slug -> number of posts carrying it. Rarer => higher weight.
    var counts = {};
    var countsEl = document.querySelector('[data-rp-tagcounts]');
    if (countsEl) {
        try { counts = JSON.parse(countsEl.textContent) || {}; } catch (e) { counts = {}; }
    }
    function weight(slug) {
        var n = counts[slug];
        if (!n || n < 1) { n = 1; }
        return 1 / n;
    }

    var cards = Array.prototype.slice.call(feed.querySelectorAll('.gh-card'));
    if (!cards.length) {
        if (section.parentNode) { section.parentNode.removeChild(section); }
        return;
    }

    var seen = {};
    var scored = [];

    cards.forEach(function (card) {
        var link = card.querySelector('.gh-card-link');
        var href = link ? link.getAttribute('href') : null;
        if (href) {
            if (seen[href]) { // duplicate across the two queries
                if (card.parentNode) { card.parentNode.removeChild(card); }
                return;
            }
            seen[href] = true;
        }

        var score = 0;
        (card.getAttribute('data-tags') || '').split(',').forEach(function (t) {
            if (t && myTags[t]) { score += weight(t); }
        });

        var tagEl = card.querySelector('.gh-card-tag');
        var cardChannels = tagEl ? (tagEl.getAttribute('data-channel') || '').trim().split(/\s+/) : [];
        var sameChannel = 0;
        cardChannels.forEach(function (c) { if (c && myChannels[c]) { sameChannel = 1; } });

        var ts = parseInt(card.getAttribute('data-timestamp') || '0', 10) || 0;

        scored.push({ card: card, score: score, sameChannel: sameChannel, ts: ts });
    });

    scored.sort(function (a, b) {
        if (b.score !== a.score) { return b.score - a.score; }                 // rarity-weighted shared tags
        if (b.sameChannel !== a.sameChannel) { return b.sameChannel - a.sameChannel; } // prefer same channel
        return b.ts - a.ts;                                                    // recency
    });

    // Reorder winners to the front; CSS hides everything past the 4th.
    var frag = document.createDocumentFragment();
    scored.forEach(function (item) { frag.appendChild(item.card); });
    feed.appendChild(frag);
})();
